import React, { useState, useMemo, useCallback } from 'react';
import { AnimatePresence, LayoutGroup } from 'framer-motion';
import { cities as seed, type CityInfo } from './cityData';
import CityCard from './CityCard';
import CityModal from './CityModal';

// Recommended Cities bölümü – grid ve modal kontrolü
export default function RecommendedCities() {
  const [activeSlug, setActiveSlug] = useState<string | null>(null);

  const cities = useMemo(() => seed, []);
  const active = useMemo<CityInfo | null>(() => cities.find(c => c.slug === activeSlug) || null, [activeSlug, cities]);

  const open = useCallback((slug: string) => setActiveSlug(slug), []);
  const close = useCallback(() => setActiveSlug(null), []);

  return (
    <section className="py-16 bg-[#f5fefd] dark:bg-background-dark transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-3xl font-bold text-center mb-10 text-gray-900 dark:text-gray-100">Önerilen Şehirler</h3>
        <LayoutGroup id="cities">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cities.map((c) => (
              <CityCard key={c.slug} city={c} onOpen={open} />
            ))}
          </div>
          {/* Modal */}
          <AnimatePresence>{(active && <CityModal city={active} onClose={close} />) || null}</AnimatePresence>
        </LayoutGroup>
      </div>
    </section>
  );
}
